const translations = {
    account: 'Acct',
    data: 'Data',
    help: 'Help',
    home: 'Home',
    maintenance: 'Maint',
    reports: 'Reps'
};

export default translations;
